import Bundle from "@framework/Bundle";

export const routes = require.context(
	"./",
	true,
	/.*\/@module($|\/routes\.(js))/
);

/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-START */
/* webpack-strip-block:removed */
export const libs = [];
export const styles = [];
export const constants = [];
export const loadable = require.context("./", true, /\.(loadable)\.(js)$/);
export const stores = [];
export const extensions = [];
export const background = require.context("./", true, /\.(background)\.(js)$/);
/* REMOVE-FOR-CLIENT-CHILD-START */
export default new Bundle(require.context("./", true, /\.bundle\.(js)$/));
/* REMOVE-FOR-CLIENT-CHILD-END */
/* webpack-strip-block:removed */
/* REMOVE-FOR-SERVER-END */
